import { render, staticRenderFns } from "./ProjectStatusMenu.vue?vue&type=template&id=153e08a4"
import script from "./ProjectStatusMenu.vue?vue&type=script&lang=js"
export * from "./ProjectStatusMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports